import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'plik'

export default {

    addSzablon(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    putSzablon(data) {
        return axios({
            method: 'put',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    getSzablony() {
        return axios({
            method: 'get',
            url: URL + '/info/list/public',
        })
    },

    getContentOfFile(url){
        return axios({
            method: 'get',
            url: url,
        })
    }

}


// WEBPACK FOOTER //
// ./src/modules/administracja/szablony/SzablonyService.js